import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueLabourCost', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/details/change-costs/issue-labour-cost/issue-labour-cost.html'),
        controller: 'IssueLabourCostController',
        controllerAs: 'IssueLabourCostCtrl',
        bindings: {
            cost: '=',
            issue: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-costs/issue-labour-cost/issue-labour-cost.component.ts